var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',{attrs:{"config":{
    ..._vm.team.canvasConfig.group,
    listening: false,
  }}},[_c('v-rect',{attrs:{"config":_vm.team.canvasConfig.rect}}),_c('v-text',{attrs:{"config":{
    ..._vm.team.canvasConfig.text,
    y: -20,
    text: `${_vm.team.name} (${_vm.team.memberCount}/${_vm.team.maxCapacity})`,
    align: 'center',
  }}}),_c('v-text',{attrs:{"config":{
    x: _vm.team.canvasConfig.group.width + 2,
    y: 0,
    text: _vm.team.taskPendingCount,
  }}}),_c('v-text',{attrs:{"config":{
    x: 0,
    y: _vm.team.canvasConfig.group.height + 2,
    text: _vm.team.taskFinishedCount,
  }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }